import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "order-list-page" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "shipping-type-label" }, "Frakttype", -1)
const _hoisted_4 = { class: "product-type" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "product-type-label" }, "Produkttype", -1)
const _hoisted_6 = { class: "search" }
const _hoisted_7 = { class: "headline" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Messages = _resolveComponent("Messages")!
  const _component_OrderListNav = _resolveComponent("OrderListNav")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_OrderList = _resolveComponent("OrderList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Messages),
    _createElementVNode("header", null, [
      _createVNode(_component_OrderListNav, {
        class: "list-nav",
        selected: _ctx.type
      }, null, 8, ["selected"]),
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"])),
        class: "filter"
      }, [
        (_ctx.type === 'weborders')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_Multiselect, {
                class: "shipping-type",
                onSelect: _ctx.submit,
                mode: "single",
                canClear: false,
                canDeselect: false,
                modelValue: _ctx.form.shipping_type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.shipping_type) = $event)),
                options: _ctx.shippingOptions
              }, null, 8, ["onSelect", "modelValue", "options"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Multiselect, {
            class: "produkt-type",
            onSelect: _ctx.submit,
            mode: "single",
            canClear: false,
            canDeselect: false,
            modelValue: _ctx.form.product_type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.product_type) = $event)),
            options: _ctx.productTypeOptions
          }, null, 8, ["onSelect", "modelValue", "options"])
        ]),
        _createVNode(_component_ButtonGroup, {
          color: "primary",
          modelValue: _ctx.form.status,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.status) = $event)),
          options: _ctx.statusOptions,
          object: false
        }, {
          default: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString((slotProps.option as any).title), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "options"]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "search",
            name: "search",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.search) = $event))
          }, null, 512), [
            [_vModelText, _ctx.form.search]
          ]),
          _createVNode(_component_Button, {
            type: "submit",
            color: "green"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Søk")
            ]),
            _: 1
          })
        ])
      ], 32)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.type === 'orders')
        ? (_openBlock(), _createElementBlock("h1", _hoisted_8, "Ordre"))
        : (_openBlock(), _createElementBlock("h1", _hoisted_9, "Webordre")),
      _createVNode(_component_Button, {
        color: "primary",
        type: "inertia-link",
        href: _ctx.route('orders.create')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SvgIcon, {
            type: "mdi",
            path: _ctx.mdiPlus
          }, null, 8, ["path"]),
          _createTextVNode(" Ny Ordre ")
        ]),
        _: 1
      }, 8, ["href"])
    ]),
    _createVNode(_component_OrderList, {
      type: _ctx.type,
      orders: _ctx.orders
    }, null, 8, ["type", "orders"])
  ]))
}